// Provides mapping between internal and user-friendly column names
// in DataTables
const accessorKeyHeaderRecord: Record<string, string> = {
  "catalogNumber": "Lot #",
  "startBid": "Start Bid",
  "appraisalMin": "Appraisal Min",
  "appraisalMax": "Appraisal Max",
  "cocode": "CoCode",
  "inventoryNumber": "Inventory #",
  "user_name": "Name",
  "user_email": "Email",
  "numberOfLots": "Number of Lots",
  "totalAmount": "Total Amount",
  "dueAt": "Due At",
  "invoiceStatus": "Invoice Status",
  "paymentMethod": "Payment Method",
};

export default accessorKeyHeaderRecord;
